import { FoodTrayTemplate } from '../../models';
import { AppState } from '../rootReducer';

export const isLoading = (state: AppState) => state.foodTrayTemplates.isLoading;
export const getFoodTrayTemplates = (state: AppState): FoodTrayTemplate[] => state.foodTrayTemplates.all;
export const getFoodTrayTemplate = (state: AppState) => state.foodTrayTemplates.one;
export const isDeleteLoading = (state: AppState) => state.foodTrayTemplates.isDeleteLoading;
export const isDuplicateLoading = (state: AppState) => state.foodTrayTemplates.isDuplicateLoading;
export const isCreateLoading = (state: AppState) => state.foodTrayTemplates.isCreateLoading;
export const isUpdateLoading = (state: AppState) => state.foodTrayTemplates.isUpdateLoading;
export const isReplaceFoodItemLoading = (state: AppState) => state.foodTrayTemplates.isReplaceFoodItemLoading;
export const isReplaceFoodItemAndStartTimerLoading = (state: AppState) =>
  state.foodTrayTemplates.isReplaceFoodItemAndStartTimerLoading;
export const isEmptyItemLoading = (state: AppState) => state.foodTrayTemplates.isEmptyItemLoading;
export const isEmptyLineLoading = (state: AppState) => state.foodTrayTemplates.isEmptyLineLoading;
export const isStartTimerLoading = (state: AppState) => state.foodTrayTemplates.isStartTimerLoading;
export const isStartTimerForExistingFoodItemLoading = (state: AppState) =>
  state.foodTrayTemplates.isStartTimerForExistingFoodItemLoading;
